// GENERATED — do not edit. Edit the source SVG under svg/air/ and re-run `pnpm build:icons`.
// Source: svg/air/A.svg

import {
  type IconPaintMode,
  type IconViewBox,
} from "../../../internal/createIconOptions";
import { type IconNode } from "../../../internal/iconNode";

export const paint: IconPaintMode = "fill";
export const viewBox: IconViewBox = "0 0 32 32";

export const iconNode = [
  [
    "path",
    {
      d: "M28.7679 15.9932H24.2551C24.7364 13.9216 24.9319 12.1375 24.9319 10.5424C24.9319 7.37339 23.5996 6 22.1868 6C19.7801 6 16.9364 8.76977 12.2889 16.56C5.23304 17.5144 2 19.6599 2 22.8766C2 24.774 3.25182 26.1063 5.35133 26.1063C8.90965 26.1063 10.9829 23.4055 13.8085 18.7433C15.8899 18.5527 18.2851 18.4492 20.9613 18.4229C20.7641 19.0225 20.5489 19.6517 20.3091 20.3138L18.9768 23.9871C18.4921 25.3391 19.0376 26.1277 19.9263 26.1277C20.4717 26.1277 20.9958 25.7646 21.2783 24.9974L22.8735 20.5766C23.1462 19.8259 23.3861 19.1063 23.598 18.4163H28.7679C29.4349 18.4163 30 18.0336 30 17.2253C30 16.417 29.4349 15.9932 28.7679 15.9932ZM5.59282 23.744C4.78456 23.744 4.4215 23.3398 4.4215 22.755C4.4215 20.9578 6.67543 19.7881 10.7545 19.1211C9.26778 21.495 7.53133 23.744 5.59282 23.744ZM15.3067 16.2429C18.7468 10.5686 20.8923 8.42314 21.7219 8.42314C22.2065 8.42314 22.5088 8.72542 22.5088 10.5424C22.5088 12.0915 22.2607 13.8329 21.6858 15.9948C19.3365 16.0096 17.2124 16.0918 15.3051 16.2429H15.3067Z",
    },
  ],
] as const satisfies IconNode;
